"use client";

import { useId } from "react";
import {
  Alert,
  Button,
  Inline,
  Input,
  Stack,
  Text,
} from "@softmax/design-system";

export type LeagueIdentityField = Readonly<{
  value: string;
  changed: boolean;
  valid: boolean;
  pending: boolean;
  saved: boolean;
  unavailable?: boolean;
  error?: string | undefined;
  onChange(value: string): void;
  onSave(): void;
  onCancel(): void;
}>;

export function IdentityField({
  label,
  action,
  field,
  description,
}: Readonly<{
  label: string;
  action: string;
  field: LeagueIdentityField;
  description?: string;
}>) {
  const id = useId();
  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();

        if (
          field.valid &&
          field.changed &&
          !field.pending &&
          !field.unavailable
        )
          field.onSave();
      }}
    >
      <Stack width="auto" gap={8}>
        <label htmlFor={id}>{label}</label>
        <Input
          id={id}
          size="sm"
          value={field.value}
          disabled={field.pending || field.unavailable}
          aria-invalid={field.changed && !field.valid}
          onChange={(event) => field.onChange(event.target.value)}
        />
        {description && <Text tone="muted">{description}</Text>}
        <Inline>
          <Button
            type="submit"
            disabled={
              !field.changed ||
              !field.valid ||
              field.pending ||
              field.unavailable
            }
          >
            {field.pending ? "Saving…" : action}
          </Button>
          <Button
            type="button"
            variant="quiet"
            disabled={!field.changed || field.pending}
            onClick={field.onCancel}
          >
            Discard edit
          </Button>
          {field.saved && <output>{label} saved.</output>}
        </Inline>
        {field.error && <Alert tone="danger">{field.error}</Alert>}
      </Stack>
    </form>
  );
}
